import React, { Component } from "react";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import { isEmpty } from 'ramda';

const styles = theme => ({
  cardHeader: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff'
  },
  cardPricing: {
    display: 'flex 100%',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
  },
  cardActions: {
    [theme.breakpoints.up('sm')]: {
      paddingBottom: theme.spacing(2),
    }
  },
  media: {
    height: 0,
    paddingTop: 498,
  },
});

class PackCard extends Component {
  render() {
    const {
      classes,
      pack,
      buildPack,
      selectedBasePack
    } = this.props;

    return (
      <Card>
        <CardHeader
          title={pack.name}
          subheader={`cost: ¥ ${pack.cost}`}
          titleTypographyProps={{ align: 'center', color: '#fff' }}
          subheaderTypographyProps={{ align: 'center', color: '#fff' }}
          className={classes.cardHeader}
        />
        <CardContent>
          <div className={classes.cardPricing}>
          <Typography variant="subtitle1" align="center">
              Base Weight: {pack.weight}g<hr/>
          </Typography>
          <Typography variant="subtitle1" align="center">
              Total Volume: {pack.volume.total}L<br/>
              Base Body: {pack.volume.body}L<br/>
              Ext Body: +{pack.volume.extended}L<br/>
              Front Pocket: {pack.volume.frontPocket}L<br/>
              Side Pocket(x2): {pack.volume.sidePockets}L<br/><hr/>
          </Typography>
          <Typography variant="subtitle1" align="center">
            Base Fabric: {pack.fabric}<hr/>
          </Typography>
          <Typography variant="subtitle1" align="center">
            Max Load: {pack.maxLoad}
          </Typography>
          </div>
        </CardContent>
        <CardActions className={classes.cardActions}>
          <Button fullWidth variant="contained" color="primary" onClick={()=> buildPack(pack)} disabled={!isEmpty(selectedBasePack)}>
            Build Now
          </Button>
        </CardActions>
      </Card>
    )
  }
}

export default withStyles(styles)(PackCard)